
import axiosApi from '@/request/index'
import Icon from 'vux/src/components/icon/index.vue'

import HeadNav from '@/components/headNav'

export default {
name:"Search",
components:{
Icon,
HeadNav
},
data(){
return{
searchContent:"",
title:'',
imgUrl:HTTP_IMG_URL,
historyList:[]
}
},
created(){
this.getHistoryData()
},
mounted(){
},
methods:{

search(){
if(this.historyList.indexOf(this.searchContent)==-1&&this.searchContent.length>0){
this.historyList.unshift(this.searchContent)
if(this.historyList.length>12){
this.historyList = this.historyList.slice(0,12)
}
localStorage.setItem('historyList',this.historyList)
}
this.$router.push({path:'/list',query:{searchContent:this.searchContent}})
},

clickHistory(item){
this.searchContent = item
this.search()
},

getHistoryData(){
this.historyList = localStorage.getItem('historyList').split(',')||[]
},

deleteHistory(){
localStorage.removeItem('historyList');
this.historyList = []
}
}

}



// WEBPACK FOOTER //
// ./src/pages/search/index.vue